import React from 'react';
import { useListContext } from 'framework/list';
import RejectExpenseButton, { RejectExpenseButtonProps } from './RejectExpenseButton';

const RejectListExpenseButton = (props: RejectExpenseButtonProps) => {
  const { reloadData } = useListContext();

  return <RejectExpenseButton {...props} onSubmit={reloadData} />;
};

export default RejectListExpenseButton;
